<template>
  <div
    v-bind:class="{ 'dropdown-item': dropdownItem }"
    class="address-item-without"
    style="cursor: pointer;"
    @click="$emit('clickItem')"
  >
    <div class="clearfix">
      <div class="float-left">
        <h6 class="h6 address-title">
          {{ location.name }}
          <i v-if="location.customer_code"
            >&nbsp;({{ location.customer_code }})</i
          >
        </h6>
      </div>

      <div class="address-services float-left">
        <div
          v-if="location.has_forklift"
          class="address-service d-inline text-muted"
          v-tooltip:bottom="'Has a forklift'"
        >
          <span class="icon">
            <svg>
              <use xlink:href="/images/icons.svg#ui-lift"></use>
            </svg>
          </span>
        </div>
        <div
          v-else
          class="address-service d-inline text-muted"
          v-tooltip:bottom="'No forklift, this may affect your pricing.'"
        >
          <span class="icon">
            <svg>
              <use xlink:href="/images/icons.svg#ui-lift-none"></use>
            </svg>
          </span>
        </div>
        <div
          v-if="location.linkedDPID"
          class="address-service d-inline text-muted"
          v-tooltip:bottom="'This is a Freighthub customer'"
        >
          <i class="fas fa-share-alt"></i>
        </div>
        <div
          v-if="location.wait_time"
          class="address-service d-inline text-muted"
          v-tooltip:bottom="
            'The average time a truck spends at this location when loading and unloading.'
          "
          :style="{ background: waittimeColour }"
        >
          <i class="far fa-clock"></i> {{ location.wait_time }}m
        </div>
        <div
          v-if="location.truck_density_band"
          class="address-service d-inline text-muted"
          v-tooltip:bottom="truckDensityHoverText"
        >
          <i
            v-if="location.truck_density_band == 1"
            class="far fa-building"
          ></i>
          <i
            v-if="location.truck_density_band == 2"
            class="far fa-building"
          ></i>
          <i v-if="location.truck_density_band == 3" class="far fa-home"></i>
          <i v-if="location.truck_density_band == 4" class="far fa-home"></i>
          <i
            v-if="location.truck_density_band == 5"
            class="far fa-tree-alt"
          ></i>
          <i
            v-if="location.truck_density_band == 6"
            class="far fa-tree-alt"
          ></i>
        </div>
      </div>

      <div class="address-services float-right">
        <div
          class="address-service d-inline text-muted"
          style="cursor:pointer;"
          v-tooltip:bottom="'Edit this location'"
          @click.stop="$emit('showForm')"
        >
          <i class="far fa-edit"></i>
        </div>
      </div>
    </div>
    <p class="address-location">
      {{ location.address.data.street_number }}
      {{ location.address.data.street_name }},
      {{ location.address.data.suburb }}, {{ location.address.data.city }}
      {{ location.address.data.post_code }}
    </p>
    <p class="address-open">
      {{
        location.opening_hours
          ? "Open " + location.opening_hours
          : "No opening hours set"
      }}
    </p>
  </div>
</template>

<script>
export default {
  name: "location-selector-item",
  props: ["location", "dropdownItem"],
  mounted() {
    this.checkDefaultLocationContactInfo(this.location);
  },
  computed: {
    waittimeColour() {
      const waitTime = Number.parseInt(this.location.wait_time);
      return this.getWaitTimeColour(waitTime);
    },
    truckDensityHoverText() {
      var baseText = "This location is calculated to be ";
      var endText = "number of trucks pass by this location.";
      switch (this.location.truck_density_band) {
        case 1:
          return baseText + "in a high truck density area. A large " + endText;
        case 2:
          return baseText + "in a high truck density area. A large " + endText;
        case 3:
          return (
            baseText + "in a medium truck density area. A medium " + endText
          );
        case 4:
          return (
            baseText + "in a medium truck density area. A medium " + endText
          );
        case 5:
          return baseText + "in a low truck density area. A low " + endText;
        case 6:
          return baseText + "in a low truck density area. A low " + endText;
        default:
          return "Whether the location is urban or rural based on truck density in the area.";
      }
    }
  },
  methods: {
    getWaitTimeColour: waitTime => {
      if (waitTime > 20) {
        return "#ff8aa3";
      }
      if (waitTime < 10) {
        return "#5cff7c";
      }
      return "#ffe978";
    },

    checkDefaultLocationContactInfo(location) {
      axios
        .get("/settings/locations/id/" + location.id)
        .then(response => {
          let newLocation = response.data.data[0];
          // console.log("refetch selected location", newLocation);
          location.contact_name = newLocation.contact_name;
          location.phone = newLocation.phone;
          if (location.ownershipStatus !== "OWNED_BY_ANOTHER") {
            if (location.contact_name === null || location.phone === null) {
              this.$swal({
                title:
                  "Please provide contact name and phone number at your location",
                type: "warning"
              }).then(() => {
                location.prompted = true;
                this.$emit("showForm", location);
              });
            }
          }
        })
        .catch(e => {
          console.log("Error refetching from server", e);
          Event.$emit("serverError");
        });
    }
  }
};
</script>
